import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import GlobalSideCartPage from "@faire/prototype-playground/workspace/sol/global-side-cart";
import BanDoPage from "@faire/prototype-playground/workspace/sol/global-side-cart/ban-do";
import GlobalSideCartCartPage from "@faire/prototype-playground/workspace/sol/global-side-cart/cart";
import GlobalSideCartCategoryPage from "@faire/prototype-playground/workspace/sol/global-side-cart/category";
import GlobalSideCartHomepagePage from "@faire/prototype-playground/workspace/sol/global-side-cart/homepage";
import LakeAndOakTeaCoPage from "@faire/prototype-playground/workspace/sol/global-side-cart/lake-and-oak-tea-co";
import MelAndrelPage from "@faire/prototype-playground/workspace/sol/global-side-cart/mel-andrel";
import PfCandlePage from "@faire/prototype-playground/workspace/sol/global-side-cart/pf-candle";
import RockysMatchaPage from "@faire/prototype-playground/workspace/sol/global-side-cart/rockys-matcha";
import RoenPage from "@faire/prototype-playground/workspace/sol/global-side-cart/roen";

const BrandSaturationAndExclusivityPage = withCompass(
  () => import("@faire/prototype-playground/workspace/sol/brand-saturation-and-exclusivity")
);
import { withCompass } from "../../components/compass/withCompass";

const BrandPageMobileNavigationPage = lazy(
  () => import("../../pages/BrandPageMobileNavigation")
);
const BrandPageNavigationDeepDivePage = withCompass(
  () => import("../../pages/BrandPageNavigationDeepDive")
);
const BrandPageNavigationPage = lazy(
  () => import("../../pages/BrandPageNavigationPage")
);
const CartPlaygroundDuplicatePage = withCompass(
  () => import("../../pages/CartPlaygroundDuplicatePage")
);
const CartSubstitutionsOosPage = withCompass(
  () => import("../../pages/CartSubstitutionsOosPage")
);
const MobileBrandNavDetailsPage = lazy(
  () => import("../../pages/MobileBrandNavDetailsPage")
);

export function SophieONeillLatulippeRoutes() {
  return (
    <Switch>
      <Route
        path="/sol/brand-page-navigation-deep-dive"
        component={BrandPageNavigationDeepDivePage}
      />
      <Route
        path="/sol/brand-page-mobile-navigation"
        component={BrandPageMobileNavigationPage}
      />
      <Route
        path="/sol/brand-page-navigation"
        component={BrandPageNavigationPage}
      />
      <Route path="/sol/brand-saturation-and-exclusivity" component={BrandSaturationAndExclusivityPage} />
      <Route
        path="/sol/cart-playground-duplicate"
        component={CartPlaygroundDuplicatePage}
      />
      <Route
        path="/sol/cart-substitutions-oos"
        component={CartSubstitutionsOosPage}
      />
      {/* exact required: /ban-do, /cart, /category, /lake-and-oak-tea-co,
          /mel-andrel, /pf-candle, /reorder, /rockys-matcha, /roen are
          sub-pages of this prototype (not their own registered prototypes),
          and without `exact` this route's prefix match would swallow them
          before the more specific routes below run.

          The prototype's initial screen is the logged-in homepage (per
          explicit request — "have the initial starting screen be the
          homepage instead of the reorder hub"), so the root path renders
          `GlobalSideCartHomepagePage`; the original multi-brand Reorder-grid
          hub (`GlobalSideCartPage`) moved to `/reorder` rather than being
          the default landing spot. */}
      <Route
        path="/sol/global-side-cart"
        exact
        component={GlobalSideCartHomepagePage}
      />
      <Route
        path="/sol/global-side-cart/ban-do"
        component={BanDoPage}
      />
      <Route
        path="/sol/global-side-cart/cart"
        component={GlobalSideCartCartPage}
      />
      <Route
        path="/sol/global-side-cart/category/:categoryName"
        component={GlobalSideCartCategoryPage}
      />
      <Route
        path="/sol/global-side-cart/lake-and-oak-tea-co"
        component={LakeAndOakTeaCoPage}
      />
      <Route
        path="/sol/global-side-cart/mel-andrel"
        component={MelAndrelPage}
      />
      <Route
        path="/sol/global-side-cart/pf-candle"
        component={PfCandlePage}
      />
      <Route
        path="/sol/global-side-cart/reorder"
        component={GlobalSideCartPage}
      />
      <Route
        path="/sol/global-side-cart/rockys-matcha"
        component={RockysMatchaPage}
      />
      <Route
        path="/sol/global-side-cart/roen"
        component={RoenPage}
      />
      <Route
        path="/sol/mobile-brand-nav-details"
        component={MobileBrandNavDetailsPage}
      />
    </Switch>
  );
}

export const slug = "sol";
